import http from '~/http/new';

export default ({
  state: {
    data: [],
    filters: {},
    sort: {
      sort: 'defaultSort',
      sortDesc: false,
    },
    page: 1,
    pages: 0,
    filterLists: {
      arrayList: [
        { id: 0, caption: 'Caption' },
      ],
    },
  },

  getters: {
    requestData(state, _getters, _rootState, rootGetters) {
      const { filters, sort, page } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      return {
        ...filters,
        ...sort,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
        getTotal: true,
      };
    },
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_SORT(state, data) { state.sort = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },

    SET_DATA(state, data) {
      state.data = data;
    },
  },

  actions: {
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setSort({ commit }, data) { commit('SET_SORT', data); },
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async loadData({ getters, commit, rootGetters }, data) {
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const response = await http.get('v1/transactions/methods', {
        params: {
          ...getters.requestData,
          ...data,
        },
      });
      const { items, total } = response.data;
      commit('SET_DATA', items);
      if (total) {
        const pages = Math.ceil(total / itemsPerPage);
        commit('SET_PAGES', pages);
      }
    },

    async edit(__store, { id, ...data }) {
      // Массив ключей, которые нужно проверить
      const keysToCheck = ['payInFee', 'payOutFee', 'payInLimit', 'payOutLimit'];
      // Дублирование объекта для изменения данных внутри
      const filteredData = { ...data };
      // Проходимся по всему объекту и заменяем пустые значения на 0
      keysToCheck.forEach((key) => {
        if (filteredData[key]) {
          Object.keys(filteredData[key]).forEach((parameter) => {
            if (filteredData[key][parameter] === '') {
              filteredData[key][parameter] = 0;
            }
          });
        }
      });
      const response = await http.put(`v1/transactions/methods/${id}`, filteredData);
      return response.data;
    },

    async create(__store, data) {
      const response = await http.post('v1/transactions/methods', data);
      return response.data;
    },
  },

  namespaced: true,
});
